import { render, staticRenderFns } from "./customComponentEdit.vue?vue&type=template&id=3bc6f56f&scoped=true"
import script from "./customComponentEdit.vue?vue&type=script&lang=js"
export * from "./customComponentEdit.vue?vue&type=script&lang=js"
import style0 from "./customComponentEdit.vue?vue&type=style&index=0&id=3bc6f56f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc6f56f",
  null
  
)

export default component.exports